import { motion, useAnimation, Variants } from 'framer-motion';
import { useEffect } from 'react';

const variants: Variants = {
    visible: {
        opacity: 1,
        transition: {
            type: 'tween',
            ease: 'easeInOut',
            duration: 0.2,
        },
    },
    hidden: {
        opacity: 0,
    },
};

export interface AnimationImageProps {
    isImageLoaded: boolean;
    children: JSX.Element | JSX.Element[];
}

export function AnimationImage(props: AnimationImageProps) {
    const { children, isImageLoaded } = props;
    const animationControls = useAnimation();

    useEffect(() => {
        if (!isImageLoaded) return;
        animationControls.start('visible');
    }, [isImageLoaded, animationControls]);

    return (
        <motion.div className="relative h-full" animate={animationControls} initial="hidden" variants={variants}>
            {children}
        </motion.div>
    );
}

export default AnimationImage;
